import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { statesApi } from '../apis/common';
import { Province } from '../interfaces/location';
import { fetchCountries } from '../states/action_creators';
import { RootState } from '../states/reducers';

const useFetchCountries = (country: number | null = null) => {
  const { countries } = useSelector((state: RootState) => state.countries);
  const [provinces, setProvinces] = useState<Province[]>([]);
  const dispatch = useDispatch();

  const handleSelectCountry = (e: React.ChangeEvent<HTMLSelectElement>) => {
    selectProvinces(e.target!.value);
  };

  const selectProvinces = useCallback(async (countryId: string) => {
    try {
      const response = await statesApi(countryId);
      const provinces: Province[] = response.data;
      const sortedProvinces = provinces.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
      setProvinces(sortedProvinces);
    } catch (error) {}
  }, []);

  useEffect(() => {
    if (!countries.length) {
      dispatch(fetchCountries());
    }

    if (country) {
      selectProvinces(country.toString());
    }
  }, [countries.length, country, selectProvinces, dispatch]);

  return { countries, provinces, handleSelectCountry };
};

export default useFetchCountries;
